import React from 'react';
import PropTypes from 'prop-types';
import SearchImage from './SearchIcon.svg';
import {Image} from '@learningblocks/storybook-components';
import style from './style.module.scss';

/**
 * SearchIcon
 *   - The search icon image.
 */
export function SearchIcon(props) {
  return (
    <span className={style.searchbox_icon} onClick={props.onClick}>
      <Image src={SearchImage} alt='Search glossary' />
    </span>
  );
}

SearchIcon.propTypes = {
  /**
   * Callback function to execute when search button is clicked.
   */
  onClick: PropTypes.func.isRequired,
};

SearchIcon.defaultProps = {};
